import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SUPPORT_EMAIL } from "@/lib/support-email";

export function ExpiredWorkspaceScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="grid min-h-screen place-items-center bg-background px-4 py-10">
      <div className="w-full max-w-xl rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <AlertTriangle className="h-7 w-7" />
        </div>
        <h1 className="text-2xl font-bold text-[#0C1F4F]">{t("subscription.expired.title")}</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          {t("subscription.expired.description")}
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            onClick={() => navigate("/upgrade-plan")}
            className="bg-accent text-accent-foreground hover:bg-accent/90"
          >
            {t("subscription.upgrade")}
          </Button>
          <Button variant="outline" asChild>
            <a href={`mailto:${SUPPORT_EMAIL}`}>
              <LifeBuoy className="mr-2 h-4 w-4" />
              {t("subscription.contactSupport")}
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
